import {Redirect, Route, Switch} from 'react-router-dom';
import {
  familyDayOutHotspots,
  m04Hotspots,
  m05Hotspots,
  m06Hotspots,
  m07Hotspots,
  m08Hotspots,
  m09Hotspots,
  m10Hotspots,
  m11Hotspots,
  m18Hotspots,
  m19Hotspots,
  m17Hotspots,
  m1Hotspots,
  m20Hotspots,
  m23Hotspots,
  m3Hotspots,
  mainRoomHotspots,
  purpleDudeHotspots,
  smallRoomHotspots,
  m16Hotspots,
  m15Hotspots,
  perspectiveHotspots,
  m14Hotspots,
  m13Hotspots,
  m12Hotspots,
  c1Hotspots,
  m22Hotspots,
  c2Hotspots,
  md01Hotspots,
  md02Hotspots,
  md03Hotspots,
  md04Hotspots,
  md05Hotspots,
  md06Hotspots,
  md07Hotspots,
  flowersToteHotspots,
} from "./data";
import NWScene from './NWScene';
import Urls from '../../constants/urls';

const NWRooms = () => {
  return (
    <Switch>
      <Route 
        {...Urls.northWind.root}
        render={() => <Redirect to={Urls.northWind.m21.path} />}  
      />

        <Route {...Urls.northWind.c1}>
          <NWScene
            id="nw-c1"
            yRotation={90}
            hotspots={c1Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.c2}>
          <NWScene
            id="nw-c2"
            yRotation={270}
            hotspots={c2Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m01}>
          <NWScene
            id="nw-m01"
            yRotation={270}
            hotspots={m1Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m02}>
          <NWScene
            id="nw-m02"
            yRotation={360}
            hotspots={smallRoomHotspots}
          />
        </Route>
        <Route {...Urls.northWind.m03}>
          <NWScene
            id="nw-m03"
            yRotation={270}
            hotspots={m3Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m04}>
          <NWScene
            id="nw-m04"
            yRotation={270}
            hotspots={m04Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m05}>
          <NWScene
            id="nw-m05"
            yRotation={270}
            hotspots={m05Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m06}>
          <NWScene
            id="nw-m06"
            yRotation={270}
            hotspots={m06Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m07}>
          <NWScene
            id="nw-m07"
            yRotation={270}
            hotspots={m07Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.purpleDude}>
          <NWScene
            id="nw-purple-dude"
            yRotation={180}
            hotspots={purpleDudeHotspots}
          />
        </Route>
        <Route {...Urls.northWind.m08}>
          <NWScene
            id="nw-m08"
            yRotation={270}
            hotspots={m08Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m09}>
          <NWScene
            id="nw-m09"
            yRotation={270}
            hotspots={m09Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m10}>
          <NWScene
            id="nw-m10"
            yRotation={270}
            hotspots={m10Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m11}>
          <NWScene
            id="nw-m11"
            yRotation={270}
            hotspots={m11Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m12}>
          <NWScene
            id="nw-m12"
            yRotation={270}
            hotspots={m12Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m13}>
          <NWScene
            id="nw-m13"
            yRotation={270}
            hotspots={m13Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m14}>
          <NWScene
            id="nw-m14"
            yRotation={270}
            hotspots={m14Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m15}>
          <NWScene
            id="nw-m15"
            yRotation={180}
            hotspots={m15Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.perspective}>
          <NWScene
            id="nw-perspective"
            yRotation={270}
            hotspots={perspectiveHotspots}
          />
        </Route>
        <Route {...Urls.northWind.m16}>
          <NWScene
            id="nw-m16"
            yRotation={270}
            hotspots={m16Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m17}>
          <NWScene
            id="nw-m17"
            yRotation={270}
            hotspots={m17Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m18}>
          <NWScene
            id="nw-m18"
            yRotation={360}
            hotspots={m18Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m19}>
          <NWScene
            id="nw-m19"
            yRotation={270}
            hotspots={m19Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m20}>
          <NWScene
            id="nw-m20"
            yRotation={270}
            hotspots={m20Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m21}>
          <NWScene
            id="nw-m21"
            yRotation={360}
            hotspots={mainRoomHotspots}
          />
        </Route>
        <Route {...Urls.northWind.m22}>
          <NWScene
            id="nw-m22"
            yRotation={180}
            hotspots={m22Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.m23}>
          <NWScene
            id="nw-m23"
            yRotation={270}
            hotspots={m23Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.familyTime}>
          <NWScene
            id="nw-family-time"
            yRotation={270}
            hotspots={familyDayOutHotspots}
          />
        </Route>
        <Route {...Urls.northWind.flowersTote}>
          <NWScene
            id="nw-flowers-tote"
            yRotation={270}
            hotspots={flowersToteHotspots}
          />
        </Route>
        <Route {...Urls.northWind.md01}>
          <NWScene
            id="nw-md01"
            yRotation={270}
            hotspots={md01Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.md02}>
          <NWScene
            id="nw-md02"
            yRotation={270}
            hotspots={md02Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.md03}>
          <NWScene
            id="nw-md03"
            yRotation={270}
            hotspots={md03Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.md04}>
          <NWScene
            id="nw-md04"
            yRotation={270}
            hotspots={md04Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.md05}>
          <NWScene
            id="nw-md05"
            yRotation={270}
            hotspots={md05Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.md06}>
          <NWScene
            id="nw-md06"
            yRotation={270}
            hotspots={md06Hotspots}
          />
        </Route>
        <Route {...Urls.northWind.md07}>
          <NWScene
            id="nw-md07"
            yRotation={270}
            hotspots={md07Hotspots}
          />
        </Route>
    </Switch>
  );
};

export default NWRooms;
